"use client"

import { ArrowRight, Heart, Users, BookOpen, Laptop } from "lucide-react"
import { Link } from "react-router-dom"
import { useState } from "react"

export const FasCallToAction = () => {
  const [buttonHover, setButtonHover] = useState(false)

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="bg-white rounded-2xl overflow-hidden shadow-2xl border border-gray-100 animate-in fade-in duration-700">
          <div className="p-6 sm:p-8 lg:p-12 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
            
            <div className="relative z-10">
              <div className="border-b border-white/20 pb-6 mb-8">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3">Support Our Mission</h2>
                <p className="text-base sm:text-lg md:text-xl text-gray-300">Help us empower students through education</p>
              </div>

              <p className="text-sm sm:text-base leading-relaxed mb-8 text-gray-200">
                Join us in transforming lives through education. Your support helps provide essential learning tools and
                resources to students who need them most. Together, we can create equal opportunities for all students to
                succeed.
              </p>

              <div className="grid sm:grid-cols-2 gap-4 mb-10">
                <div className="flex items-start gap-4 bg-white/5 backdrop-blur-sm rounded-lg p-4 hover:bg-white/10 transition-colors duration-300">
                  <div className="p-2 rounded-lg" style={{ backgroundColor: 'rgb(249 115 22)' }}>
                    <BookOpen className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <span className="font-semibold block mb-1">Notebooks & Stationery</span>
                    <span className="text-sm text-gray-300">Provide essential writing materials to students</span>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-white/5 backdrop-blur-sm rounded-lg p-4 hover:bg-white/10 transition-colors duration-300">
                  <div className="p-2 rounded-lg" style={{ backgroundColor: 'rgb(249 115 22)' }}>
                    <Laptop className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <span className="font-semibold block mb-1">Digital Devices</span>
                    <span className="text-sm text-gray-300">Supply technology for modern learning</span>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-white/5 backdrop-blur-sm rounded-lg p-4 hover:bg-white/10 transition-colors duration-300">
                  <div className="p-2 rounded-lg" style={{ backgroundColor: 'rgb(249 115 22)' }}>
                    <Users className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <span className="font-semibold block mb-1">Educational Programs</span>
                    <span className="text-sm text-gray-300">Support community initiatives</span>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-white/5 backdrop-blur-sm rounded-lg p-4 hover:bg-white/10 transition-colors duration-300">
                  <div className="p-2 rounded-lg" style={{ backgroundColor: 'rgb(249 115 22)' }}>
                    <Heart className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <span className="font-semibold block mb-1">Lasting Impact</span>
                    <span className="text-sm text-gray-300">Create positive change in students' lives</span>
                  </div>
                </div>
              </div>

              <Link to="/contact">
                <button
                  className="w-full rounded-lg px-6 sm:px-8 py-4 font-bold uppercase tracking-wide transition-all duration-300 flex items-center justify-center gap-3 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 text-sm sm:text-base"
                  style={{
                    backgroundColor: buttonHover ? 'white' : '#f59e0b',
                    color: buttonHover ? '#f59e0b' : 'white'
                  }}
                  onMouseEnter={() => setButtonHover(true)}
                  onMouseLeave={() => setButtonHover(false)}
                >
                  <Heart className="w-5 h-5" />
                  Donate Now
                  <ArrowRight className="w-5 h-5" />
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
